import { CMSPath, PRE_CHECKIN } from "../config/Constant";
import { CHECK_IN, GUEST_ITINERARY, GUEST_REQUEST, HCOMMERCE, IFRAME_RENDERER, MY_BILL, TABLE_RESERVATION } from "../navigation/StackNavigator/routes";
import { checkPreCheckInWidgetState } from "./preCheckInWidgetState";

export const navItemsConstant = [
    {
        compName: "Mobile Check-in",
        alterNativeName: [
            "Mobile Check-in",
            "mobile check-in",
        ],
        path: CHECK_IN,
        image: null
    },
    {
        compName: "Pre Check-in",
        alterNativeName: [
            "pre check-in",
            "pre checkin",
        ],
        path: CHECK_IN,
        image: null
    },
    {
        compName: "URL Renderer",
        alterNativeName: [
            "url renderer",
            "urlrenderer"
        ],
        path: null,
        image: null
    },
    {
        compName: "URL iFrame Renderer",
        alterNativeName: [
            "url iframe renderer",
            "URL Iframe Renderer"
        ],
        path: IFRAME_RENDERER,
        image: null,
    },
    {
        compName: "URL iFrame Renderer (Open Default)",
        alterNativeName: [
            "url iframe renderer (open default)"
        ],
        path: null,
        image: null,
    },
    {
        compName: "Guest Details",
        alterNativeName: [
            "guest details",
            "guest detail"
        ],
        path: null,
        image: null
    },
    {
        compName: "Guest Requests",
        alterNativeName: [
            "guest request",
            "guest requests"
        ],
        path: GUEST_REQUEST,
        image: null
    },
    {
        compName: "Grouped Service Requests",
        alterNativeName: [
            "grouped service requests"
        ],
        path: GUEST_REQUEST,
        image: null
    },
    {
        compName: "View My Bill",
        alterNativeName: [
            "view my bill",
            "view bill"
        ],
        path: MY_BILL,
        image: null
    },
    {
        compName: "Restaurant Reservation",
        alterNativeName:[
            "restaurant reservation",      
        ],
        path: TABLE_RESERVATION,
        image: null
    },
    {
        compName: "Room service",
        alterNativeName: [
            "h-commerce",
            "hcommerce",
    
        ],
        path: HCOMMERCE,
        image: null
    },
    {
        compName: "Guest Itinerary",
        alterNativeName: [
            "guest itinerary",
            "guestitinerary",
    
        ],
        path: GUEST_ITINERARY, 
        image: null
    }
]



export const mapWidgetsToNavItem = (props, widgetsData, navItemsConstant) => {
    if (!widgetsData || widgetsData.length === 0) return widgetsData;

    let updatedWidgetsData = widgetsData.map((item) => ({
        ...item,
        widgets: processSupportedWidgetsToNav(props, item.widgets, navItemsConstant),
    }));

    return updatedWidgetsData;
};

export const mapFloatingWidgetsToNavItem = (floatingWidgets, navItemsConstant) => {
    if(floatingWidgets?.length){
        let mappedFloatingWidgets = floatingWidgets.map((item)=>{
            let currentWidget = {...item};
            const currentWidgeDisplayType = currentWidget?.widgetType;
            const matchingConstant = navItemsConstant.find(item => item?.alterNativeName.includes(currentWidgeDisplayType?.toLowerCase()));
        
            if(matchingConstant?.path){
                currentWidget = {...currentWidget, path: matchingConstant.path, supported: true};
            }

            return currentWidget;
        })

        return mappedFloatingWidgets;
    }
}


const processSupportedWidgetsToNav = (props, widgets, navItemsConstant) => {

    const {dispatch} = props;

    let updatedWidgetsData = widgets.map((widget) => {
        const subWidgetsArray = widget.subWidgetMap.map((subWidget) => {

            const matchedNavItem = navItemsConstant.find(navItem =>
                navItem.alterNativeName.includes(subWidget.widgetType.toLowerCase())
            );

            if (matchedNavItem) {
                let updatedSubWidgetData = {
                    ...subWidget,
                    path: matchedNavItem.path,
                    supported: true,
                    alterNativeName: matchedNavItem.alterNativeName,
                    compName: matchedNavItem.compName,
                    compImage: subWidget.btnImageUrl ? `${CMSPath}${subWidget.btnImageUrl}` : matchedNavItem.image,
                };

                if(updatedSubWidgetData.path == HCOMMERCE) getAllHcommerceStoreDataInLayout(props, updatedSubWidgetData);

                return updatedSubWidgetData;
            }


            console.log("This widget is not supported", subWidget.widgetType);
            return {...subWidget, supported: false};
        });

        return {
            ...widget,
            subWidgetMap: subWidgetsArray,
        };
    })


    return sortByPositionHandler(updatedWidgetsData);
};

const sortByPositionHandler = (navItems) => {
    if (!navItems || navItems.length === 0) return [];

    return navItems.slice().sort((a, b) => a.position - b.position);
};

const getAllHcommerceStoreDataInLayout = (props, storeData) => {
    const { dispatch, setHcommerceStoreSkuData } = props;

    dispatch(setHcommerceStoreSkuData({ [storeData.storeSku]: storeData }));
};